export function lang() {
  
  let language = '';
  if(window.sessionStorage.getItem("online_exam_language") === undefined
    || window.sessionStorage.getItem("online_exam_language") === null
    || window.sessionStorage.getItem("online_exam_language") === "") {
      if(window.localStorage.getItem("online_exam_language") === undefined
        || window.localStorage.getItem("online_exam_language") === null
        || window.localStorage.getItem("online_exam_language") === "") {
          language = 'vi';
    }else{
      language = window.localStorage.getItem("online_exam_language");
    }
  } else {
    language = window.sessionStorage.getItem("online_exam_language");
  }
  window.sessionStorage.setItem("online_exam_language",language);
  if ("zh" === language
    || "zh-tw" === language
    || "zh-hk" === language
    || "zh_CN" === language
    || "zh-CN" === language) {
    return "1"
  } else if ("en" === language
    || "en-US" === language
    || "en-au" === language
    || "en-nz" === language
    || "en-tt" === language
    || "en-za" === language
    || "nl-be" === language) {
    return "2"
  } else if ("ja" === language
    || "ja_JP" === language
    || "ja-JP" === language) {
    return "3"
  } else if ("vi" === language
    || "vi-VN" === language
    || "ve" === language) {
    return "4"
  } else {
    return "4"
  }
}





// WEBPACK FOOTER //
// ./src/assets/languages/getLanguageType.js